import { useQuery } from 'react-query';

import type { ISnippet } from 'src/services/api/snippets';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_SNIPPETS_PATH } from 'src/services/api/snippets/constants';

export type IGetSnippetsResponse = {
    private: Array<ISnippet>;
    team: Array<ISnippet>;
}

export const useSnippets = () => {
    return useQuery(
        [queryKeys.snippets],
        async () => {
            const res = await apiClient(GET_SNIPPETS_PATH).json<IGetSnippetsResponse>();
            return [...res.private, ...res.team];
        }
    );
};